import dayjs from "dayjs";
import "dayjs/locale/ru";

export default {
  install(Vue) {
    dayjs.locale("ru");

    Vue.prototype.$dayjs = dayjs;
    Vue.dayjs = dayjs;

    Vue.filter("dayjs", (date, format) => {
      // If input is an integer with fewer than 12 digits, assume it's seconds...
      if (date.toString().length < 12) {
        date = date * 1000;
      }
      return dayjs(date).format(format);
    });
  }
};

export { default as dayjs } from "dayjs";
